const TYPE_EXCHANGE = 'exchange';
const TYPE_WALLET = 'wallet';
const TYPE_WALLET_WEB = 'wallet_web';
const TYPE_APP_PAY = 'app_pay';
const TYPE_PROMO = 'promo';
const TYPE_MANUAL = 'manual';

const WALLET_TYPES = {
  TYPE_EXCHANGE,
  TYPE_WALLET,
  TYPE_WALLET_WEB,
  TYPE_APP_PAY,
  TYPE_PROMO,
  TYPE_MANUAL,
}

const POLKAWALLET_NAME = 'Polkawallet';
const COINBASE_NAME = 'Coinbase Wallet';
const METAMASK_NAME = 'MetaMask';
const FREEWALLET_NAME = 'FreeWallet';
const GUARDAWALLET_NAME = 'Guarda Wallet';
const BITPAY_NAME = 'BitPay Wallet';

const WALLETS_DATA = {
  binance_pay: {
    name: 'Binance Pay',
    type: TYPE_APP_PAY,
  },
  gate_pay: {
    name: 'Gate Pay',
    type: TYPE_APP_PAY
  },
  klub: {
    name: 'Klubcoin',
    type: TYPE_PROMO
  },
  ncdt: {
    name: 'NCDT',
    type: TYPE_PROMO
  },
  // wallets
  lunu_wallet: {
    type: TYPE_WALLET,
    name: 'Lunu Wallet',
  },
  token_pocket: {
    type: TYPE_WALLET,
    name: 'TokenPocket'
  },
  clover_wallet: {
    type: TYPE_WALLET,
    name: 'CLV Wallet',
  },
  polka_wallet: {
    name: POLKAWALLET_NAME,
    type: TYPE_WALLET,
  },
  exodus: {
    name: 'Exodus',
    type: TYPE_WALLET,
  },
  blockchain_wallet: {
    name: 'Blockchain Wallet',
    type: TYPE_WALLET,
  },
  coinbase_wallet: {
    name: COINBASE_NAME,
    type: TYPE_WALLET,
  },
  trust_wallet: {
    name: 'Trust Wallet',
    type: TYPE_WALLET,
  },
  meta_mask: {
    name: METAMASK_NAME,
    type: TYPE_WALLET,
  },
  crypto_com: {
    name: 'Crypto.com | DeFi Wallet',
    type: TYPE_WALLET,
  },
  im_token: {
    name: 'imToken Wallet',
    type: TYPE_WALLET,
  },
  bitcoin_com_wallet: {
    name: 'Bitcoin.com Wallet',
    type: TYPE_WALLET,
  },
  jaxx_wallet: {
    name: 'Jaxx Liberty',
    type: TYPE_WALLET,
  },
  abra_wallet: {
    name: 'Abra Wallet',
    type: TYPE_WALLET,
  },
  ledger_live: {
    name: 'Ledger Live',
    type: TYPE_WALLET,
  },
  luno: {
    name: 'Luno Wallet',
    type: TYPE_WALLET,
  },
  coinomi_wallet: {
    name: 'Coinomi Wallet',
    type: TYPE_WALLET,
  },
  mycelium_wallet: {
    name: 'Mycelium Wallet',
    type: TYPE_WALLET,
  },
  safe_pal: {
    name: 'SafePal',
    type: TYPE_WALLET,
  },
  electrum_bitcoin: {
    name: 'Electrum Bitcoin Wallet',
    type: TYPE_WALLET,
  },
  btc_com_wallet: {
    name: 'BTC.com Wallet',
    type: TYPE_WALLET,
  },
  enjin_wallet: {
    name: 'Enjin Wallet',
    type: TYPE_WALLET,
  },
  paxful: {
    name: 'Paxful',
    type: TYPE_WALLET,
  },
  edge_wallet: {
    name: 'Edge Wallet',
    type: TYPE_WALLET,
  },
  eidoo_wallet: {
    name: 'Eidoo Wallet',
    type: TYPE_WALLET,
  },
  phantom: {
    name: 'Phantom',
    type: TYPE_WALLET,
  },
  free_wallet: {
    name: FREEWALLET_NAME,
    type: TYPE_WALLET,
  },
  ku_coin: {
    name: 'KuCoin',
    type: TYPE_WALLET,
  },
  samourai_wallet: {
    name: 'Samourai Wallet',
    type: TYPE_WALLET,
  },
  shape_shift: {
    name: 'ShapeShift',
    type: TYPE_WALLET,
  },
  status: {
    name: 'Status',
    type: TYPE_WALLET,
  },
  lumi_wallet: {
    name: 'Lumi Wallet',
    type: TYPE_WALLET,
  },
  huobi: {
    name: 'Huobi',
    type: TYPE_WALLET,
  },
  guarda_wallet: {
    name: GUARDAWALLET_NAME,
    type: TYPE_WALLET,
  },
  bitnovo: {
    name: 'Bitnovo',
    type: TYPE_WALLET,
  },
  blue_wallet: {
    name: 'BlueWallet',
    type: TYPE_WALLET,
  },
  zen_go_wallet: {
    name: 'ZenGo Wallet',
    type: TYPE_WALLET,
  },
  bit_pay_wallet: {
    name: BITPAY_NAME,
    type: TYPE_WALLET,
  },
  particl_copay: {
    name: 'Particl Copay',
    type: TYPE_WALLET,
  },
  eclair_mobile: {
    name: 'Eclair Mobile',
    type: TYPE_WALLET,
  },
  wall_eth: {
    name: 'WallETH',
    type: TYPE_WALLET,
  },
  blw: {
    name: 'BLW',
    type: TYPE_WALLET,
  },
  trustee_wallet: {
    name: 'Trustee Wallet',
    type: TYPE_WALLET,
  },
  wallet_satoshi: {
    name: 'Wallet of Satoshi',
    type: TYPE_WALLET,
  },
  my_ton_wallet: {
    name: 'MyTonWallet',
    type: TYPE_WALLET,
  },
  telegram_wallet: {
    name: 'Telegram Wallet',
    type: TYPE_WALLET,
  },
  tonkeeper: {
    name: 'Tonkeeper',
    type: TYPE_WALLET,
  },
  tonhub: {
    name: 'Tonhub',
    type: TYPE_WALLET,
  },
  // web
  polka_wallet_web: {
    name: POLKAWALLET_NAME,
    type: TYPE_WALLET_WEB,
  },
  polkadot_js_web: {
    name: 'Polkadot{.js}',
    type: TYPE_WALLET_WEB,
  },
  binance_wallet_web: {
    name: 'Binance Wallet',
    type: TYPE_WALLET_WEB,
  },
  coinbase_wallet_web: {
    name: COINBASE_NAME,
    type: TYPE_WALLET_WEB,
  },
  meta_mask_web: {
    name: METAMASK_NAME,
    type: TYPE_WALLET_WEB,
  },
  jaxx_wallet_web: {
    name: 'Jaxx Liberty',
    type: TYPE_WALLET_WEB,
  },
  btc_com_wallet_web: {
    name: 'BTC.com Wallet',
    type: TYPE_WALLET_WEB,
  },
  free_wallet_web: {
    name: FREEWALLET_NAME,
    type: TYPE_WALLET_WEB,
  },
  lumi_wallet_web: {
    name: 'Lumi Wallet',
    type: TYPE_WALLET_WEB,
  },
  guarda_wallet_web: {
    name: GUARDAWALLET_NAME,
    type: TYPE_WALLET_WEB,
  },
  bit_pay_wallet_web: {
    name: BITPAY_NAME,
    type: TYPE_WALLET_WEB,
  },
  bitgo_web: {
    name: 'BitGo',
    type: TYPE_WALLET_WEB,
  },
  brave_wallet_web: {
    name: 'Brave Wallet',
    type: TYPE_WALLET_WEB,
  },
  tronlink_web: {
    name: 'TronLink',
    type: TYPE_WALLET_WEB,
  },
  // exchange
  cxw_coinbase: {
    name: 'Coinbase',
    type: TYPE_EXCHANGE,
  },
  cxw_crypto_com: {
    name: 'Crypto.com',
    type: TYPE_EXCHANGE,
  },
  cxw_kucoin: {
    name: 'KuCoin',
    type: TYPE_EXCHANGE,
  },
  cxw_blockchain_com: {
    name: 'Blockchain.com',
    type: TYPE_EXCHANGE,
  },
  cxw_bitfinex: {
    name: 'Bitfinex',
    type: TYPE_EXCHANGE,
  },
  cxw_gemini: {
    name: 'Gemini',
    type: TYPE_EXCHANGE,
  },
  cxw_kraken: {
    name: 'Kraken',
    type: TYPE_EXCHANGE,
  },
  cxw_bitpanda: {
    name: 'Bitpanda Pro',
    type: TYPE_EXCHANGE,
  },
  cxw_bitstamp: {
    name: 'Bitstamp',
    type: TYPE_EXCHANGE,
  },
  cxw_okx: {
    name: 'OKX',
    type: TYPE_EXCHANGE,
  },

  // custom

  other: {
    name: 'Other Wallet',
    type: TYPE_MANUAL,
  },
};


module.exports = {
  WALLET_TYPES,
  WALLETS_DATA,
}
